"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escapeRegExp = escapeRegExp;
exports.dimensionValueToString = dimensionValueToString;

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function dimensionValueToString(value) {
  return value ? value.toString() : '0';
}